module.exports = __webpack_public_path__ + "img/4.ce3e93d9.png";